import { TPpdApp } from "../../App/PpdApp";
import { TPpdTaskBase } from "../../App/PpdBaseTask";

export class AppMenuTask extends TPpdTaskBase {



}

ScriptInit(new TPpdApp(), new AppMenuTask());